'use strict';

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const Formatters=require('../../../dist-es6/client/formatters');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const AlertStatusCache=require('../../../dist-es6/client/viewModels/alertStatusCache');let

IncidentViewModel=class IncidentViewModel{
constructor(time,incidentType,fatigue,statistics,viewScheduleFunc,timezone,id){
_.ensureInstanceOf(Date,time);
_.ensureInstanceOf('string',incidentType.code);
_.ensureInstanceOf('string',incidentType.description);
_.ensureInstanceOf(['nullable','number'],fatigue);
_.ensureInstanceOf(['nullable','object'],statistics);
_.ensureInstanceOf(Function,viewScheduleFunc);
_.ensureInstanceOf('string',timezone);

this._time=time;
this._incidentType=incidentType;
this._fatigue=fatigue||null;
this._statistics=statistics||null;
this._viewSchedule=viewScheduleFunc;
this._timezone=timezone;
this._id=id;

this._statusCache=new AlertStatusCache(nt=>this._thresholdStatusFor(nt));
this._fatigueForDisplay=Math.floor(fatigue||0);

const[dayOfWeek,dateString,hourString]=Formatters.formatInLocale(this._time,
'ddd|YYYY-MM-DD|HH:00',
timezone,
{displayTimeZone:!1}).split('|');

this._buckets={dayOfWeek,dateString,hourString};
}

static createFrom(rawIncident,incidentType,timezone,viewScheduleFunc){
return new IncidentViewModel(
new Date(rawIncident.time),
incidentType,
rawIncident.fatigue,
rawIncident.statistics,
viewScheduleFunc,
timezone,
rawIncident.id);
}

get id(){
return this._id;
}

get dayOfWeek(){
return this._buckets.dayOfWeek;
}

get hourString(){
return this._buckets.hourString;
}

get dateString(){
return this._buckets.dateString;
}

get timezone(){
return this._timezone;
}

get time(){
return this._time;
}

get code(){
return this._incidentType.code;
}

get description(){
return this._incidentType.description;
}

get fatigue(){
return this._fatigue;
}

get fatigueForDisplay(){
return this._fatigueForDisplay;
}

get statistics(){
return this._statistics;
}

viewSchedule(){
this._viewSchedule();
}

set currentlyScopedGroupMemberships(value){
this._statusCache.clear();
this._currentlyScopedGroupMemberships=value;
}

thresholdFor(notificationType){
const effectiveThresholdMap=ThresholdStatus.getEffectiveThresholdsForMultipleGroups(this._currentlyScopedGroupMemberships,_.get(this.statistics,'recentHistory.fatigue'),[notificationType]);
return effectiveThresholdMap.get(notificationType);
}

_thresholdStatusFor(notificationType){
return ThresholdStatus.fromScoreAndThreshold(this.fatigue,this.thresholdFor(notificationType));
}

thresholdStatusFor(notificationType){
return this._statusCache.get(notificationType);
}};


module.exports=IncidentViewModel;
//# sourceMappingURL=incidentViewModel.js.map
